// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__6Tj-p","signatureButtonsRight":"ModalSign_signatureButtonsRight__1EKdZ"};